import domainMapper from './domain-mapper';

//CDK3.5活动ID
export const ACTIVITY_ID = 'dlc3.5';

// noinspection JSUnresolvedVariable
export const ZT_ROOT_ADDRESS = DEPLOY_ENV === 'master' ? domainMapper.getWsUrl() : '//test-ws.xoyo.com';

// noinspection JSUnresolvedVariable
export const XOYO_PLATFORM_ADDRESS = DEPLOY_ENV === 'master' ? domainMapper.getPfUrl() : '//my-api-dev.xoyo.com';

// noinspection JSUnresolvedVariable
export const PASSPORT_ROOT_ADDRESS = `${XOYO_PLATFORM_ADDRESS}/passport/common_api`;

// noinspection JSUnresolvedVariable
export const PASSPORT_USER_ROOT_ADDRESS = DEPLOY_ENV === 'master' ? `${XOYO_PLATFORM_ADDRESS}/passport/user_api` : '//my-api-dev.xoyo.com/passport/user_api';

// noinspection JSUnresolvedVariable
export const CAPTCHA_XOYO_PRE_AUTH = `${PASSPORT_ROOT_ADDRESS}/pre_auth`;

// noinspection JSUnresolvedVariable
export const CAPTCHA_ZT_PRE_AUTH = DEPLOY_ENV === 'master' ? `${ZT_ROOT_ADDRESS}/core/captcha/pre_auth` : '//test-ws.xoyo.com/core/captcha/pre_auth';

// noinspection JSUnresolvedVariable
export const CAPTCHA_XOYO_PIC_URL = `${XOYO_PLATFORM_ADDRESS}/passport/common_api/captcha`;

// noinspection JSUnresolvedVariable
export const CAPTCHA_ZT_PIC_URL = `${ZT_ROOT_ADDRESS}/core/captcha/create`;

// noinspection JSUnresolvedVariable
export const XOYO_AUTH_URL = DEPLOY_ENV === 'master' ? '//m.xoyo.com' : '//m-dev.xoyo.com';

// noinspection JSUnresolvedVariable
// OMNI（新CMS）的接口站点
export const OMNI_ROOT_ADDRESS = DEPLOY_ENV === 'master' ? '//omni-api.seasungames.cn' : '//omni-api.seasungames.cn';

// noinspection JSUnresolvedVariable
/**
 * xoyo 登录地址
 */
export const XOYO_LOGIN_URL =
  DEPLOY_ENV === 'master'
    ? 'https://m.xoyo.com/passport/signin.html?hide-header=true&redirect='
    : 'https://m-dev.xoyo.com/passport/signin.html?hide-header=true&redirect=';

/**
 * daily 拼接地址
 * @type {string}
 */
export const M3U8_DAILY_PREPREND_URL = '//wvcdn.pvp.xoyo.com/';

/**
 * 实物领奖地址
 */
export const REAL_AWARD_URL =
  DEPLOY_ENV === 'master' ? '//jx3.xoyo.com/m/common/award-form/0.0.12/#/real' : '//test-zt.xoyo.com/jx3.xoyo.com/m/common/award-form/0.0.12/#/real';

/**
 * 虚拟领奖地址(区服角色)
 */
export const VIRTUAL_AWARD_URL =
  DEPLOY_ENV === 'master'
    ? '//jx3.xoyo.com/m/common/award-form/0.0.12/#/pc-virtual'
    : '//test-zt.xoyo.com/jx3.xoyo.com/m/common/award-form/0.0.12/#/pc-virtual';

/**
 * 虚拟领奖只选(区服)
 */
export const VIRTUAL_AWARD_ZONE_URL =
  DEPLOY_ENV === 'master'
    ? '//jx3.xoyo.com/m/common/award-form/0.0.12/#/virtual-zone'
    : '//test-zt.xoyo.com/jx3.xoyo.com/m/common/award-form/0.0.12/#/virtual-zone';

/**
 * 获取全国行政省市区数据
 * @type {string}
 */
export const DISTRICT_LIST = `${ZT_ROOT_ADDRESS}/core/district/get_list`;

/**
 * 生成短链
 * @type {string}
 */
export const CREATE_TINY_URL = `${ZT_ROOT_ADDRESS}/core/tinyurl/create`;
